import { render, staticRenderFns } from "./NonaktifPasien.vue?vue&type=template&id=fe452eda"
import script from "./NonaktifPasien.vue?vue&type=script&lang=js"
export * from "./NonaktifPasien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe452eda')) {
      api.createRecord('fe452eda', component.options)
    } else {
      api.reload('fe452eda', component.options)
    }
    module.hot.accept("./NonaktifPasien.vue?vue&type=template&id=fe452eda", function () {
      api.rerender('fe452eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/NonaktifPasien.vue"
export default component.exports